import { EnvIdentifier } from 'lib/enums/env';
import { EnvConfig } from 'lib/interfaces/env';

const ENV_PROD: EnvConfig = {
  identifier: 'prod',
  self_url: 'https://books.bridgeme.ca',
  server_url: 'https://books.bridgeme.ca/api',
};

const ENV_LOCAL: EnvConfig = {
  identifier: 'local',
  self_url: 'http://localhost:4000',
  server_url: 'http://localhost:3000',
};

/** based on target REACT_APP_STAGE from build command */
const mainEnvConfig = (): EnvConfig => {
  switch (process.env.REACT_APP_STAGE as EnvIdentifier) {
    case 'prod':
      return ENV_PROD;

    default:
      return ENV_LOCAL;
  }
};

const config = mainEnvConfig();
export default config;
